export const HAIR_SCALP = 'hair-scalp';
export const TREATMENTS = 'treatments';
export const LIFESTYLE = 'lifestyle';
export const PREFERENCES_GOALS = 'preferences-goals';
